<template>
  <SubContent h="550px" @back="type !== 'view' && type !== 'audit' ? showTip = true : $router.go(-1)">
    <template v-slot:nav_left>
      <p v-if="type === 'edit'">编辑本赛事取得成绩({{recordName}})</p>
      <p v-else-if="type === 'view'">查看本赛事取得成绩({{recordName}})</p>
      <p v-else-if="type === 'audit'">审核本赛事取得成绩({{recordName}})</p>
      <p v-else>添加本赛事取得成绩({{recordName}})</p>
    </template>
    <template v-slot:nav_right>
      <div v-if="type === 'audit'" class="yioks_btn yioks_audit" @click="handleAuditTarget">
        结果确认
      </div>
      <div v-if="recordAuditList.length > 0" class="yioks_btn" @click="handleViewAuditList" >
        审核记录
      </div>
    </template>
    <div class="mediaFormWrap">
      <vue-scroll>
        <el-form
          ref="formData"
          :model="formData"
          :rules="formRules"
          class="demo-form-inline"
          label-width="155px"
        >
          <el-row>
              <el-col :span="12">
                <el-form-item label="赛事类型" prop="squadSex">
                  <el-select
                    v-model="formData.squadSex"
                    style="width: 100%"
                    placeholder="请选择当前赛事类型"
                    @change="changeSquadType(formData.squadSex,true)"
                    :disabled="disabledState"
                  >
                    <el-option
                        v-for="(item,index) in squadType"
                        :key="index"
                        :label="item.sex"
                        :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="赛事分组" prop="squadLevel">
                  <el-select
                    v-model="formData.squadLevel"
                    style="width: 100%"
                    placeholder="请选择当前赛事分组"
                    :disabled="disabledState"
                  >
                    <el-option
                      v-for="(item,index) in squadLevelList"
                      :key="index"
                      :value="item"
                      :label="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="机构参赛球队名称" prop="squadName">
                <el-input v-model="formData.squadName" placeholder="请输入机构参赛球队名称" :disabled="disabledState"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="取得成绩" prop="squadRanking">
                <el-select v-model="formData.squadRanking" :disabled="disabledState" style="width: 100%">
                  <el-option label="请选择取得成绩" value=""></el-option>
                  <el-option
                    v-for="(item, index) in recordToScoreList"
                    :key="index"
                    :label="'第'+item.ranking+'名'"
                    :value="item.ranking"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="备注" prop="description">
              <el-input
                v-model="formData.description"
                type="textarea"
                :rows="4"
                placeholder="请输入备注"
                :disabled="disabledState"
              ></el-input>
            </el-form-item>
          </el-row>
          <template>
            <el-row style="display: flex; align-items: center; margin-bottom: 20px">
              <el-col :span="11" style="border-bottom: 1px dashed white" ></el-col>
              <el-col :span="6" style="text-align: center">秩序册中参赛球员信息</el-col>
              <el-col style="border-bottom: 1px dashed white" :span="11" ></el-col>
            </el-row>
            <el-row v-if="type !== 'view' && type !== 'audit'" class="link" style="display: flex; justify-content: center">
              <el-col :span="5" class="link_col">
                <div class="link_div">
                  <el-button type="primary" @click="startLinkDialog('player', '从本机构球员名单中添加') " >
                    从本机构球员名单中添加
                  </el-button>
                </div>
              </el-col>
              <el-col :span="5" :offset="1" class="link_col" >
                <div class="link_div">
                  <el-button type="primary" @click="showTransfer">
                    添加已转会球员
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </template>
          <!--球员列表-->
          <template>
            <div class="list_wrap">
              <div v-if="playerListALL.length > 0" class="table">
                <div class="thead">
                  <div class="tr">
                    <div class="th seq"><strong>序号</strong></div>
                    <div class="th idName"><strong>球员名字</strong></div>
                    <div class="th idNumber"><strong>身份证号</strong></div>
                    <div class="th position"><strong>位置</strong></div>
                    <div class="th state"><strong>球员状态</strong></div>
                    <div class="th state"><strong>转会球员证明</strong></div>
                  </div>
                </div>
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in playerListALL"  class="tr">
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <template v-if="item.uuid && (type === 'view' || type === 'audit')">
                          <div class="td idName" >
                            <p><span class="itemName" @click="goPlayerDetail(item.uuid)">{{ item.idName }}</span></p>
                          </div>
                        </template>
                        <template v-else>
                          <div class="td idName" >
                            <p>{{ item.idName }}</p>
                          </div>
                        </template>
                        <div class="td idNumber">
                          <p>{{ item.idNumber | filterIdNumberPrivacy }}</p>
                        </div>
                        <div class="td position">
                          <p>{{ item.position || '--' }}</p>
                        </div>
                        <div class="td state">
                          <p v-if="item.uuid">机构球员</p>
                          <p v-else>已转会</p>
                        </div>
                        <div class="td state">
                          <p v-if="item.documentUrl">
                            <a v-if="checkDownload(item.documentTitle)"
                              :href="$yioksConfig.transferBaseOnly(item.documentUrl)"
                              target="_blank"
                              title="证明文件"
                              style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                            >查看证明文件</a>
                            <a v-else
                              :href="'http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent($Base64.encode($yioksConfig.transferBaseOnly(item.documentUrl)))"
                              target="_blank"
                              :download="item.documentUrl"
                              title="证明文件"
                              style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                            >查看证明文件</a>
                          </p>
                          <p v-else> -- </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
              <template v-if="playerListALL.length === 0">
                <yioks-empty tips="暂时没有球员信息" class="h" style="margin-top: 0.2rem"></yioks-empty>
              </template>
            </div>
          </template>
          <!--提交审核信息-->
          <template v-if="type === 'audit' || this.type === 'view'">
            <el-row style="display: flex; align-items: center; margin-bottom: 20px">
              <el-col :span="11" style="border-bottom: 1px dashed white" ></el-col>
              <el-col :span="4" style="text-align: center">证明材料信息</el-col>
              <el-col style="border-bottom: 1px dashed white" :span="11" ></el-col>
            </el-row>

            <template v-if="recordProveInfo.description">
              <el-row>
                <el-form-item label="证明材料列表">
                  <el-input
                      v-model="recordProveInfo.description"
                      type="textarea"
                      :rows="4"
                      placeholder="请列出您提交的证明材料文件名称"
                      :disabled="disabledState"
                  ></el-input>
                </el-form-item>
              </el-row>
            </template>
            <el-row v-for="(item, index) in downloadFilelist" :key="index">
              <el-form-item :label="'证明材料文件'+(index+1)" >
                <a v-if="checkDownload(item.fileName)"
                   :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                   target="_blank"
                   :title="item.fileName"
                   style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                >{{ item.fileName }}</a>
                <a v-else
                  :href="'http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent($Base64.encode($yioksConfig.transferBaseOnly(item.fileUrl)))"
                  target="_blank"
                   :download="item.fileName"
                   :title="item.fileName"
                   style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                >{{ item.fileName }}</a>
              </el-form-item>
            </el-row>
            <template v-if="downloadFilelist.length === 0">
              <yioks-empty tips="暂时没有上传证明文件信息" class="h" style="margin-top: 0.2rem"></yioks-empty>
            </template>

          </template>
        </el-form>
      </vue-scroll>
    </div>
    <template v-slot:btn>
      <div v-if="type !== 'view' && type !== 'audit'" class="btn_wrap_media">
        <el-button type="warning" style="margin-right: 20px" :disabled="disabled" @click="checkForm('temporarily')" >暂时保存 </el-button>
        <el-button type="primary" style="margin-right: 20px" :disabled="disabled" @click="checkForm('next')" >下一步 </el-button>
        <el-button type="danger" @click="showTip = true">取消</el-button>
      </div>
    </template>
    <yioks-tip
      :showTip="showTip"
      tipMsg="确定放弃修改并返回吗，您填写的信息将不会被保存?"
      @callback="goBack"
    ></yioks-tip>
    <yioks-tips-scroll
        :showTip="showSucessTip"
        :tipMsg="tips"
        @callback="addRecordYouthToSquad"
    ></yioks-tips-scroll>
    <yioks-tip
        :showTip="temporarily"
        :tipMsg="tips"
        @callback="saveTemporarily"
    ></yioks-tip>
    <template v-if="showDialog">
      <associateSquadPlayerDialog
        :type="link.type"
        :obj="propObj"
        :title="link.title"
        :squardList="squardList"
        :organUuid="formData.organUuid"
        :youthUuid="formData.youthUuid"
        :showDialog.sync="showDialog"
        @hideDialog="hideDialog"
      ></associateSquadPlayerDialog>
    </template>
    <template v-if="showTransferDialog">
      <associateSquadTransferPlayerDialog
          :isShowDialog="showTransferDialog"
          :player="playerListWrite"
          @hideTransferDialog="hideTransferDialog"
      ></associateSquadTransferPlayerDialog>
    </template>

    <!-- 审核弹窗 -->
    <template v-if="isShowAudit">
      <record-audit-msg
          :isShow.sync="isShowAudit"
          :recordUuid="recordUuid"
          :msgUuid="recordYouthToSquadUuid"
          recordType="match"
          @callback="orgAuditCallback"
      >
      </record-audit-msg>
    </template>

    <!-- 审核日志列表 -->
    <template v-if="isShowAuditList">
      <audit-history-list
          :isShow.sync="isShowAuditList"
          :auditList="recordAuditList"
          @callback1="orgAuditCallback"
      >
      </audit-history-list>
    </template>

  </SubContent>
</template>

<script>
import recordVerify from "@/utils/formRules/record";
import storage from "@/utils/storage";
import record from '@/api/record'
import squad from "@/api/squad";
export default {
  name: "addRecordYouthToSquad",
  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    associateSquadPlayerDialog: () => import("@/components/record/associatedSquadPlayer"),
    associateSquadTransferPlayerDialog: () => import("@/components/record/associatedSquadTransferPlayer"),
    "yioks-tips-scroll": () => import("@/components/YioksTipScroll"),
    "record-audit-msg": () => import("@/components/record/recordAuditDialog"),
    "audit-history-list": () => import("@/components/record/AuditHistoryList"),
  },
  mixins: [recordVerify],
  data() {
    return {
      img: "",
      type: this.$route.query.type || "",
      recordUuid: this.$route.query.recordUuid || "",
      organUuid: this.$route.query.organUuid || "",
      youthUuid: this.$route.query.youthUuid || "",
      recordYouthToSquadUuid: this.$route.query.uuid || "",
      recordToScoreList: [], // 配置得分
      recordToSquadList: [], // 配置球队
      recordName: '', // 赛事名称
      squadType:[],
      squadLevelList:[],
      squadLevelMale:[],
      squadLevelFemale:[],
      squadLevelMixed:[],
      propObj: {},
      playerObj: {},
      showTip: false,
      showDialog: false,
      showTransferDialog: false,
      showSucessTip: false,
      temporarily: false,
      selectOrganList: [],
      selectCenterList: [],
      disabled: false,
      link: {
        title: "",
        type: "",
      },
      playerList: [], // 已选择球员列表
      playerListWrite: [], // 自己写的球员列表
      playerListALL: [], // 全部球员列表
      squardList: [],
      uuid: storage.get("userInfo").uuid,
      userRole: storage.get("userInfo").userRole,
      formData: {
        squadSex: "", //球队性质
        squadLevel: "", //球队级别
        squadName: "", //球队名称
        squadRanking: "", //名次
        description: "", //描述
        youthUuid: "", //机构uuid
        youthShortName: "", //青训机构简称
        organShortName: "", // 会员协会简称
        organUuid: "", // 会员协会uuid
      },
      auditSquad: {},
      tips: "",
      recordAuditList: [], // 审核日志列表
      isShowAuditList: false, // 审核
      recordProveInfo: {}, // 机构证明材料信息
      downloadFilelist: [], // 机构证明材料文件信息
      isShowAudit: false, // 审核
      disabledState: false,
    };
  },
  created() {
    if (this.type === "audit" || this.type === "view") {
      this.disabledState = true;
    }
    // 获取详情接口
    if (this.type === "edit" || this.type === "view" || this.type === "audit") {
      this.getRecordYouthToSquadInfo(); // 获取详情接口
      this.getRecordAuditList(); // 获取审核日志列表
    }else {
      this.getCenterList(); //获取当前机构的球队
    }
    this.getRecordInfo(); // 查询配置信息

    if (this.type === "audit" || this.type === "view"){
      this.getRecordProveInfo(); // 证明材料信息
    }



  },
  filters:{},
  methods: {
    checkDownload (fileName) {
      let patten = /\.(jpg|jpeg|gif|bmp|png|pdf)$/i
      return patten.test(fileName)
    },
    // 查询配置信息
    getRecordInfo() {
      record.getRecordInfo(this.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordName = res.recordName;
        this.recordToScoreList = res.recordToScoreList;
        this.recordToSquadList = res.recordToSquadList;
        let tmp =[];
        this.recordToSquadList.map(item => { // 获取球队类型
          let tmpMap = {};
          if (tmp.indexOf(item.squadSex) === -1) {
            tmpMap.sex = item.squadSex === "male" ? "男足" : item.squadSex === "mixed" ? "与其他单位球员联合组队" : "女足";
            tmpMap.value = item.squadSex;
            tmp.push(item.squadSex);
            this.squadType.push(tmpMap);
          }

          if(item.squadSex === "male"){
            this.squadLevelMale.push(item.squadLevel);
          }
          if(item.squadSex === "female"){
            this.squadLevelFemale.push(item.squadLevel);
          }
          if(item.squadSex === "mixed"){
            this.squadLevelMixed.push(item.squadLevel);
          }
        })
        this.changeSquadType(this.formData.squadSex,false);
      }).catch(err => {
        console.error(err)
      })
    },

    // 获取球队级别
    changeSquadType(type,change){
      if(change){
        this.formData.squadLevel = '';
      }
      if(type === "male"){
        this.squadLevelList = this.squadLevelMale;
      }
      if(type === "female"){
        this.squadLevelList = this.squadLevelFemale;
      }
      if(type === "mixed"){
        this.squadLevelList = this.squadLevelMixed;
      }
    },

    // 编辑获取详情
    getRecordYouthToSquadInfo() {
      record.getRecordYouthToSquadInfo(this.recordYouthToSquadUuid).then((res) => {
        const { squadSex, squadLevel, squadName, squadRanking, description, uuid, youthUuid, youthShortName, organShortName, organUuid } = res;

        this.formData = {squadSex, squadLevel, squadName, squadRanking, description, uuid, youthUuid, youthShortName, organShortName, organUuid}
        // 构造列表数组
        res.recordYouthToSquadToPlayerList.forEach((item) => {
          let uploadedList = [];
          if(item.documentUrl) {
            uploadedList = [
              {
                name: item.documentTitle,
                url: item.documentUrl,
              }
            ]
          }
          const playerListData = {
            recordUuid: item.recordUuid,
            recordYouthToSquadUuid: item.recordYouthToSquadUuid,
            uuid: item.playerUuid, // 球员uuid
            idName: item.idName,
            position: item.position,
            idNumber: item.idNumber,
            idType: item.idType,
            documentUrl: item.documentUrl || '',
            documentTitle: item.documentTitle || '',
            fileList : uploadedList
          }
          this.playerListALL.push(playerListData);
        });

        if (this.playerListALL.length > 0) {
          this.playerListALL.forEach((item) => {
            if (item.uuid){
              this.playerList.push(item);
              this.playerObj[item.uuid] = item;
            }else {
              this.playerListWrite.push(item);
            }

          });
        }
        this.getCenterList();
      });
    },

    // 证明材料信息
    getRecordProveInfo() {
      record.getRecordProveInfo(this.recordUuid,this.recordYouthToSquadUuid,'match').then((res) => {
        if (res.uuid) {
          const { uuid,recordUuid, recordYouthToSquadUuid, recordType, description,recordProveFileList } = res;
          this.recordProveInfo = res;
          this.downloadFilelist = recordProveFileList;
        }
      });
    },

    // 获取审核日志列表
    getRecordAuditList() {
      record.getRecordAuditList(this.recordUuid,this.recordYouthToSquadUuid,'match').then((res) => {
        this.recordAuditList = res;
      });
    },

    // 已转会球员
    showTransfer(){
      this.showTransferDialog = true;
    },
    // 关联系统中球员
    startLinkDialog(type, title, list) {
      this.$set(this.link, "type", type);
      this.$set(this.link, "title", title);
      this.$set(this.link, "list", list);

      if (type === "player") {
        this.propObj = { ...this.playerObj,};
      }
      this.showDialog = true;
    },

    //获取当前机构的球队
    getCenterList() {
      let data = this.uuid;
      let request = squad.getOrgListByYouth;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin"|| this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else {
        request = squad.getOrgListByCoachOrLeader;
        data = "";
      }
      request(data).then((res) => {
        this.selectOrganList = res;
        if (this.type === "edit") {
          const { organUuid, youthUuid } = this.formData;
          res.forEach((item) => {
            if (organUuid === item.organUuid) {
              const { youthList } = item;
              if (youthList && youthList.length) {
                youthList.forEach((subItem) => {
                  if (youthUuid === subItem.uuid)
                    this.squardList = subItem.squadList;
                });
              } else {
                this.squardList = [];
              }
            }
          });
          const { organUuid: checkUuid } = this.formData;
          this.selectCenterList =
            this.selectOrganList.find((item) => {
              return item.organUuid === checkUuid;
            }).youthList || [];
        } else {
          if (this.selectOrganList.length === 1) {
            this.formData.organUuid = this.selectOrganList[0].organUuid;
            this.formData.organShortName = this.selectOrganList[0].organShortName;
            this.selectCenterList = this.selectOrganList[0].youthList || [];
            if (this.selectCenterList.length === 1) {
              this.formData.youthUuid = this.selectCenterList[0].uuid;
              this.formData.youthShortName =
                this.selectCenterList[0].youthShortName;
              this.squardList = this.selectCenterList[0].squadList;
            }
          }else if (this.userRole === "system"){
            this.formData.organUuid = this.organUuid;
            this.formData.youthUuid = this.youthUuid;
            this.selectOrganList.find((item) => {
              if(item.organUuid === this.organUuid){
                this.formData.organShortName = item.organShortName;
                this.selectCenterList = item.youthList;
                if (this.selectCenterList.length === 1) {
                  this.formData.youthUuid = this.selectCenterList[0].uuid;
                  this.formData.youthShortName =
                    this.selectCenterList[0].youthShortName;
                  this.squardList = this.selectCenterList[0].squadList;
                }else{
                  this.selectCenterList.find((item) => {
                    if(item.uuid === this.youthUuid){
                      this.formData.youthShortName = item.youthShortName;
                      this.squardList = item.squadList;
                    }
                  })
                }
              }
            })
          }
        }
      });
    },

    // 取消按钮
    goBack(isSure) {
      if (isSure) {
        this.$router.go(-1);
      }
      this.showTip = false;
    },

    // 关联系统中球员回调信息
    hideDialog(val, type) {
      this.playerList = [];
      for(let key in val){
        this.playerList.push(val[key]);
      }
      if (this.playerList.length > 0){
        this.playerListALL = this.playerList.concat(this.playerListWrite);
      }else {
        this.playerListALL = this.playerListWrite;
      }
      if (type === "player") {
        this.playerObj = { ...val  };
      }
    },

    // 填写已转会球员信息
    hideTransferDialog(flag,val) {
      if (flag){
        if (val){
          this.playerListWrite = [];
          this.playerListWrite = val;
        }
        this.playerListWrite.map(item=>{
          item.position = item.position.join(",")
        })
        if (this.playerList.length > 0){
          this.playerListALL = this.playerList.concat(this.playerListWrite);
        }else {
          this.playerListALL = this.playerListWrite;
        }
      }else{

      }
      this.showTransferDialog = false
    },

    // 确认提交验证
    checkForm(val) {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          // 下一步必须有球员
          if (val !== "temporarily") {
            if(this.playerListALL.length === 0){
              this.$message.error("请参赛添加球员");
              return
            }
          }

          // 审核球队
          // 构造球队中球员
          let recordYouthToSquadToPlayerList = this.playerListALL.map((item) => {
            const {uuid, idName, position, idNumber, idType} = item;
            return {
              recordUuid: this.recordUuid,
              playerUuid: uuid,
              idName,
              position, // 球员位置
              idNumber,
              idType
            };
          });
          let squadScore;
          this.recordToScoreList.map((item)=>{
            if (this.formData.squadRanking === item.ranking){
              squadScore = item.score
            }
          })

          const data = {
            ...this.formData,
            squadScore,
            recordUuid: this.recordUuid,
            recordYouthToSquadToPlayerList: recordYouthToSquadToPlayerList,
          };
          let request = record.auditRecordYouthToSquad;
          request(data).then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
            } else {
              this.auditSquad = res;
              if (val !== "temporarily") {
                this.showSucessTip = true;

                if (res.auditState === false && res.playerAuditState === false){ // 球队、球员全部正确
                  this.tips = '本赛事取得成绩信息审核通过，信息提交后将不可进行编辑修改，是否确提交上海足协审核。';
                }else if (res.auditState === true && res.playerAuditState === true){ // 球队、球员全部错误
                  this.tips = '进入下一步，请点击“确定”上传本次赛事所取得成绩名次的证明材料，并同时上传【'+res.playerErrorList+'】等球员参与本次赛事的证明材料。';
                }else if (res.auditState === true && res.playerAuditState === false){ // 球队错误、球员正确
                  this.tips = '进入下一步，请点击“确定”上传本次赛事所取得成绩名次的证明材料或上传申报队参赛名单页。';
                }else if (res.auditState === false && res.playerAuditState === true){ // 球队正确、球员错误
                  this.tips = '进入下一步，请点击“确定”上传【'+res.playerErrorList+'】等球员参与本次赛事的证明材料。';
                }
              }else {
                this.temporarily = true;
                this.tips = '确定暂时保存并返回吗?';
              }
            }
          });

        } else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },

    // 确认提交
    addRecordYouthToSquad(flag) {
      if (flag) {
        // 构造球队中球员
        let recordYouthToSquadToPlayerList = this.playerListALL.map((item) => {
          const {uuid, idName, position, idNumber, idType,documentUrl,documentTitle} = item;
          return {
            recordUuid: this.recordUuid,
            playerUuid: uuid,
            idName,
            position, // 球员位置
            idNumber,
            idType,
            documentUrl,
            documentTitle
          };
        });
        let squadScore;
        this.recordToScoreList.map((item)=>{
          if (this.formData.squadRanking === item.ranking){
            squadScore = item.score
          }
        })

        const data = {
          ...this.formData,
          squadScore,
          recordUuid: this.recordUuid,
          recordYouthToSquadToPlayerList: recordYouthToSquadToPlayerList,
          recordSquadAuditVo: this.auditSquad,
          temporarily: false,
        };
        let request;
        if (this.type === "edit") {
          request = record.editRecordYouthToSquad;
          data.uuid = this.recordYouthToSquadUuid;
        } else {
          request = record.addRecordYouthToSquad;
        }
        request(data).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            // 验证球队、球员是否正确,不进入审核页面，直接退出
            if (this.auditSquad.auditState === false && this.auditSquad.playerAuditState === false){
              this.$router.go(-1);
            }else {
              // 进入审核页面
              this.$router.push({
                path: 'addRecordYouthToSquadAudit',
                query: {
                  recordUuid: res.recordUuid,
                  recordYouthToSquadUuid: res.uuid,
                  ...this.$route.query
                }
              })
            }

          }
        });
      } else {
        this.showSucessTip = false;
      }
    },

    // 暂时保存
    saveTemporarily(flag) {
      if (flag) {
        // 构造球队中球员
        let recordYouthToSquadToPlayerList = this.playerListALL.map((item) => {
          const {uuid, idName, position, idNumber, idType,documentUrl,documentTitle} = item;
          return {
            recordUuid: this.recordUuid,
            playerUuid: uuid,
            idName,
            position, // 球员位置
            idNumber,
            idType,
            documentUrl,
            documentTitle
          };
        });
        let squadScore;
        this.recordToScoreList.map((item)=>{
          if (this.formData.squadRanking === item.ranking){
            squadScore = item.score
          }
        })

        const data = {
          ...this.formData,
          squadScore,
          recordUuid: this.recordUuid,
          recordYouthToSquadToPlayerList: recordYouthToSquadToPlayerList,
          recordSquadAuditVo: this.auditSquad,
          temporarily: true,
        };
        let request;
        if (this.type === "edit") {
          request = record.editRecordYouthToSquad;
          data.uuid = this.recordYouthToSquadUuid;
        } else {
          request = record.addRecordYouthToSquad;
        }
        request(data).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.$router.go(-1);
          }
        });
      } else {
        this.temporarily = false;
      }
    },

    // 审核该组织
    handleAuditTarget() {
      this.isShowAudit = true;
    },
    // 审核弹窗回调
    orgAuditCallback(status) {
      if (status) {
        this.$router.back();
      }
    },

    // 查看审核记录
    handleViewAuditList() {
      this.isShowAuditList = true;
    },
    // 查看球员信息
    goPlayerDetail (uuid) {
      this.$router.push({
        path: '/player/info',
        query: {
          uuid
        }
      })
    },
  },
};
</script>
<style lang="stylus">
@import '~@/assets/css/variable'
.mediaFormWrap
  height 100%
  padding 20px 0 20px 20px
  .link
    padding-bottom 15px
    .link_col
      text-align center
  .demo-form-inline
    padding-right 30px
    .el-form-item__label
      color white
      font-size 16px
  .upload-demo
    .is-success
      &:hover
        color #4cd964
    .el-upload-list__item-name
      color #4cd964
    .el-progress-bar__inner
      background-color #4cd964
    .el-progress__text
      color #4cd964
.btn_wrap_media
  width 100%
  display flex
  justify-content center

.yioks_audit
  background #F88594
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden
  margin-bottom 20px
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    .thead, .tbody
      border 1px solid $color_white
    .thead
      .tr
        height 45px
        display flex
    .tbodyWrap
      display block
    .tbody
      display block
      width 840px
      max-width 840px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
      .itemName
        cursor pointer
        user-select none
        color $green_color
    .th, .td
      height 100%
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .seq
      width 10%
    .idName
      width 25%
    .idNumber
      width 24%
    .position
      width 15%
    .state
      width 13%
</style>
